/**
 * @description Gestion de la FAQ
 */

/* global Drupal */

(function (Drupal) {
	// VARS
	const faq = document.querySelector('[data-js-faq-root]');
	const faqItem = document.querySelectorAll('[data-js-faq-item]');
	const faqToggleAll = document.querySelector('[data-js-btn-toggle-all]');

	// FUNCTION

	const faqToggleAllControls = () => {
		// eslint-disable-next-line no-unused-vars
		let count = 0;
		faqItem.forEach((item) => {
			if (item.classList.contains('active')) {
				// eslint-disable-next-line no-unused-vars
				count++;
			}
		});
		faqToggleAll.addEventListener('click', () => {
			if (faqToggleAll.classList.contains('active')) {
				faqToggleAll.setAttribute('aria-expanded', 'true');
				faqItem.forEach((item) => {
					item.classList.add('active');
					item.querySelector('.faq__item__answer').classList.add(
						'active'
					);
					item.querySelector('.faq__item__toggle').classList.add(
						'active'
					);
				});
			} else {
				faqToggleAll.setAttribute('aria-expanded', 'false');
				faqItem.forEach((item) => {
					item.classList.remove('active');
					item.querySelector('.faq__item__answer').classList.remove(
						'active'
					);
					item.querySelector('.faq__item__toggle').classList.remove(
						'active'
					);
				});
			}
		});
	};

	// GO 🚀
	if (document.body.contains(faq)) {
		faqToggleAllControls();
	}
})(Drupal);
